import React from 'react';
import { Stack, Box, Typography, TextField } from '@mui/material';
import { useTargetingConfigContext } from './TargetingConfigContext';

export const InterestsConfig = () => {
  const { interests, setInterests } = useTargetingConfigContext();

  return (
    <Stack gap={5} alignItems="flex-start">
      <Box width={{ xs: '100%', sm: '55%' }}>
        <Typography fontWeight={700} mb={4}>
          Was interessiert deine Zielgruppe? Nenne ein paar Stichworte.
        </Typography>
        <TextField
          label="Interessen"
          placeholder="E.g: Reisen, Tennis, Umweltschutz, ..."
          value={interests[0]}
          onChange={(e) => setInterests([e.target.value])}
          multiline
          minRows={3}
          maxRows={6}
          fullWidth
          size="small"
          sx={{
            '& .MuiInputBase-root.MuiOutlinedInput-root': {
              padding: '8px',
              background: '#FFFFFF',
            },
            '& .MuiInputBase-input.MuiInputBase-inputMultiline': {
              padding: '7px',
            },
          }}
        />
      </Box>
    </Stack>
  );
};
